// Application constants
export const APP_CONSTANTS = {
    // Hardcoded broker value for authentication
    BROKER_ID: 'fa21902ba0e3eb02ff0b48e92ee432703af90bc50a31741891ccda4fea8abbee'
};
